const mapStateToProps = (state) => {
    const {
        ui:{
            selectedGeoObjArray,
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
        }={},
        api:{
            geoObjDashboard,
        }={},
        service:{
            Api:{
                getGeoObjDashboard
            }={}
        }={}
    } = state;
    // const selectedGeoObj = state?.ui?.selectedGeoObj;
    // const getGeoObjDashboard = state?.service?.Api?.getGeoObjDashboard;
    // const geoObjDashboard = state?.api?.geoObjDashboard;
    return { 
      selectedGeoObjArray, 
      getGeoObjDashboard, 
      geoObjDashboard, 
      dateRangeCriteria,
      rangeStartDate, 
      rangeEndDate, 
    }
}


export default mapStateToProps;